module.exports = "/images/_/_/_/_/api.acadevian.com/resources/js/src/assets/images/icons/parachute.svg";